import dayjs from "dayjs";
import FormBuilder from "../form_components/FormBuilder";
import Input from "../form_components/Input";
import React, { useState } from "react";
import Button from "components/Button";
import axios from "axios";
import IprojectData from "interfaces/projectData.interface";

type QuickRange = "1h" | "1d" | "1w";

interface ExportProps {
    project: IprojectData;
    context: string;
};

export default function Export({ project, context}: ExportProps) {
    const formatForInput = (date: dayjs.Dayjs): string => {
        return date.format("YYYY-MM-DDTHH:mm");
    };
    const [with_failures, setWithFailures] = useState(false);
    const [specify_period, setSpecifyPeriod] = useState(false);
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");
    const getExport = () => {
        axios.get(`${process.env.REACT_APP_API_URI}/projects/export?project=${project?.id}&context=${context}&with_failures=${with_failures}&start_date=${start_date}&end_date=${end_date}`, {
            responseType: "blob",
        })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", project?.name + ".csv" || "export.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => console.error(err));
    };

    return (
        <>
            <FormBuilder title='Export Project' onSubmit={getExport}>
                {({ setFieldValue }) => {
                    const setQuickRange = (range: QuickRange): void => {
                        const now = dayjs();
                        let from: dayjs.Dayjs;

                        switch (range) {
                            case "1h":
                                from = now.subtract(1, "hour");
                                break;
                            case "1d":
                                from = now.subtract(1, "day");
                                break;
                            case "1w":
                                from = now.subtract(1, "week");
                                break;
                        }
                        
                        setFieldValue("start_date", formatForInput(from));
                        setStartDate(formatForInput(from));
                        setFieldValue("end_date", formatForInput(now));
                        setEndDate(formatForInput(now))
                        setFieldValue("specified_period", true);
                    };

                    return (
                        <>
                            <Input
                                width=''
                                label="Include failed actions"
                                type='checkbox'
                                extraClasses='border flex rounded px-2 dark:border-black'
                                name='with_failures'
                                placeholder={""}
                                value={with_failures}
                                onChange={(name, value)=>setWithFailures(Boolean(value))}
                            />

                            <Input
                                width=""
                                label="Specific period"
                                type="checkbox"
                                extraClasses="border flex rounded px-2 dark:border-black"
                                name="specified_period"
                                placeholder=""
                                value={specify_period}
                                onChange={(name, value)=>setSpecifyPeriod(Boolean(value))}
                            />
                            {specify_period ?
                            <>
                            <Input
                                width='full'
                                label="From:"
                                type='datetime-local'
                                placeholder=''
                                extraClasses='border block rounded px-2'
                                required={false}
                                name='start_date'
                            />

                            <Input
                                width='full'
                                label="To:"
                                type='datetime-local'
                                placeholder=''
                                extraClasses='border block rounded px-2'
                                required={false}
                                name='end_date'
                            />

                            <div className="flex gap-2 mt-3">
                                <Button onClick={() => setQuickRange("1h")} label={"Last 1 hour"} width={"1/3"} />
                                <Button onClick={() => setQuickRange("1d")} label={"Last 1 day"} width={"1/3"} />
                                <Button onClick={() => setQuickRange("1w")} label={"Last 1 week"} width={"1/3"} />
                            </div>
                            </>
                        :<div></div>}
                        </>
                    );
                }}
            </FormBuilder>
        </>
    );
}